import { combineReducers } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { auth } from './auth';
import { chat } from './chat';
import { startApp } from '../actions/AppActions';
export function useAppDispatch() {
  return useDispatch();
}
export function useAppSelector(selector) {
  return useSelector(selector);
}
export const rootReducer = combineReducers({
  auth,
  chat
});
export const initialState = rootReducer(undefined, startApp());